import styled from 'styled-components'

export const Root = styled.div`
  line-height: 1.5rem;
`
